export const getBrowserLocale = (fallback = 'es-ES'): string => {
  if (typeof navigator === 'undefined' || !navigator.language) {
    return fallback;
  }

  return navigator.language;
};

export const formatCurrency = (
  value: number,
  options: { locale?: string; currency?: string } = {},
): string => {
  const locale = options.locale ?? getBrowserLocale();
  const currency = options.currency ?? 'EUR';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    useGrouping: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};
